<div class="{{localService.selectedLanguageCode}}"
  *ngIf="localService.languageContent != null && localService.languageContent.deliverer">
  <div class="row freeze_height" *ngIf="myDeliverer">
    <div class="col-sm-4">
      <div style="display: inline-flex;" *ngIf="source && !isShowOnlyPinned">
        <app-label [isWrap]="true" [Text]="localService.languageContent.local_locations.postal_code">
        </app-label>
        <input autocomplete="off" type="text" class="input_full" [ngClass]="postalCode == '' ? '' : 'en'"
          style="width:calc(100% - 35px);" [(ngModel)]="postalCode"
          placeholder="{{localService.languageContent.local_locations.postal_code}}"
          title="{{localService.languageContent.local_locations.postal_code}}" (keydown.enter)="onLoad()" />
        <i style="float:right;margin-top:10px;" class="material-icons button" (click)="onLoad()">search</i>
      </div>
    </div>
    <div class="col-sm-4" *ngIf="myDeliverer.key == ''">
      <button *ngIf="!localService.isServiceProviderBlocked()" type="button" class="btn btn-primary" style="margin:5px;"
        (click)="onClick(1)">{{localService.languageContent.deliverer.new_deliverer}}</button>
      <div *ngIf="localService.isServiceProviderBlocked()">
        {{localService.languageContent.deliverer.suspended}}
      </div>
    </div>
    <div class="col-sm-4" *ngIf="myDeliverer.key != ''">
      <div *ngIf="!localService.isServiceProviderBlocked()">
        <i class="material-icons button icon_adjust" (click)="onClick(2)">mode_edit</i>
        <i class="material-icons button icon_adjust" *ngIf="!localService.isHideDummy"
          [ngStyle]="{'opacity' : myDeliverer.v4 == '' ? '0.5' : '1'}"
          (click)="onClick(6,myDeliverer.v4,localService.selected.countryCode)">format_list_numbered</i>
        <button type="button" class="btn btn-primary" style="margin:5px;" *ngIf="!isActive"
          (click)="onClick(3)">{{localService.languageContent.deliverer.make_active}}</button>
        <button type="button" class="btn btn-primary" style="margin:5px;" *ngIf="isActive && isPrivate"
          (click)="onClick(4)">{{localService.languageContent.deliverer.make_public}}</button>
        <label style="font-weight: normal; margin-left: 30px;" *ngIf="isActive">
          <input type="checkbox" [(ngModel)]="isCommitted" (change)="onClick(5)" />
          <span class="normal_color">{{localService.languageContent.deliverer.i_am_committed}}</span>
        </label>
      </div>
      <div *ngIf="localService.isServiceProviderBlocked()">
        {{localService.languageContent.deliverer.suspended}}
      </div>
    </div>
    <div class="col-sm-4" style="text-align:right">
      <button type="button" class="btn btn-primary" style="margin:5px;" (click)="onClick(7)">{{ isShowOnlyPinned ?
        localService.languageContent.deliverer.show_all_items :
        localService.languageContent.deliverer.show_only_pinned_items}}</button>
    </div>
  </div>
  <div *ngIf="source && source.content.items.length > 0">
    <div class="banner center" style="margin-top:10px;">
      <div class="custom_rows_body" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
        <div class="row styled_row freeze_col" *ngFor="let item of source.content.items">
          <div class="col-md-4">
            <i class="material-icons button icon_adjust" [ngStyle]="{'color' : item.v8 == '1' ? '#008CBA' : 'grey'}"
              (click)="onSavePinnedItem(item.key,item.v8 == '1')">push_pin</i>
            <i class="material-icons icon_adjust" [ngStyle]="{'color' : item.v3 == '1' ? 'green' : 'red'}">circle</i>
            <i class="material-icons button icon_adjust" *ngIf="!localService.isHideDummy"
              [ngStyle]="{'opacity' : item.v4 == '' ? '0.5' : '1'}"
              (click)="onClick(6,item.v4,source.locations.selected.key)">format_list_numbered</i>
            <span [ngClass]="localService.getLanguageCode(item.v2)" class="button"
              (click)="localService.showSummary(item.key,4)">{{item.v1}}</span>
          </div>
          <div class="col-md-4">
            <span [ngClass]="localService.getLanguageCode(item.v6)">{{item.v5}}</span>
          </div>
          <div class="col-md-4">
            <span class="en">{{item.v7}} ; {{item.v9}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-paging *ngIf="source && !isShowOnlyPinned" [paging]="source.content.paging" [IsSimple]="true"
    (onPagingRefreshed)="onLoad()"></app-paging>
</div>